import { Pipe, PipeTransform } from '@angular/core';

/**
 * SafeJsonPipe - A pipe that safely stringifies objects with circular references
 * This pipe handles circular references and DOM objects that can't be serialized
 */
@Pipe({
  name: 'safeJson',
  standalone: true
})
export class SafeJsonPipe implements PipeTransform {
  transform(value: any): string {
    // Create a new object with only serializable properties
    return this.stringifySafely(value);
  }

  /**
   * Safely stringify an object, handling circular references
   */
  private stringifySafely(obj: any): string {
    const seen = new WeakSet();
    
    return JSON.stringify(obj, (key, value) => {
      // Skip properties that start with underscore (often internal properties)
      if (key.startsWith('_')) {
        return undefined;
      }
      
      // Handle DOM elements and other non-serializable objects
      if (value instanceof HTMLElement || value instanceof Node) {
        return '[DOM Element]';
      }
      
      // Handle audio elements specifically
      if (key === 'audioHtml' || key === 'audioElement') {
        return '[Audio Element]';
      }

      // Handle functions
      if (typeof value === 'function') {
        return '[Function]';
      }
      
      // Handle circular references
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return '[Circular Reference]';
        }
        seen.add(value);
      }
      
      return value;
    }, 2);
  }
}
